import Operation from './Operation.js';

class EditPattern extends Operation {
    constructor(mix, event, patternNumber) {
        super(mix, event.getType());

        this.event = event;
        this.patternNumber = patternNumber;
    }

    execute() {
        this.event.patternNumber = this.patternNumber;
    }
}

export default EditPattern;
